import { useCallback, useRef } from 'react';

import { useMapContext } from '../../context';

/**
 * @description
 * Хук проверяет, что размеры карты изменились
 */
export const useMapSizeChanged = (): (() => boolean) => {
  const { map } = useMapContext();

  const mapSize = useRef(map.container.getSize());

  return useCallback(() => {
    const newMapSize = map.container.getSize();
    const isMapSizeChanged = mapSize.current !== newMapSize;

    if (isMapSizeChanged) {
      mapSize.current = newMapSize;
    }

    return isMapSizeChanged;
  }, [map.container]);
};
